module.exports = __webpack_public_path__ + "static/media/question.5772dfac.png";